module.exports = __webpack_public_path__ + "img/point_to.4133dbcc.svg";